<div class="parent-container">
  <p-toast />
  <p-confirmDialog />
  @if (!renderList) {
    <p-progressSpinner></p-progressSpinner>
  }
  @else {
    <p-dataView #dv [value]="renderList" [rows]="5" [paginator]="true">
      <ng-template pTemplate="header">
        <div class="header-container">
          <h1>My Renders</h1>
          <div class="button-group">
            @if (renderPipelineId) {
              <p-button
                label="Render Status"
                [outlined]="true"
                icon="pi pi-spin pi-cog"
                severity="success"
                (onClick)="openRenderStatus()"
                >
              </p-button>
            }
            <p-button
              label="Create Render"
              [outlined]="true"
              icon="pi pi-file-plus"
              [loading]="newPipelineRequested && !renderPipelineId "
              severity="info"
              (onClick)="openPipeline()"
              ></p-button>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="list" let-renderList>
        @for (item of renderList; track item) {
          <div class="render-container">
            <div class="left">
              <div class="thumbnail-container">
                <div class="thumbnail-image">
                  <div class="overflow-container">
                    <p-skeleton [style.display]="!loadedImages[item.id] ? 'inline' : 'none'" width="100%" height="100%"></p-skeleton>
                    <img crossorigin="anonymous" [style.display]="loadedImages[item.id] ? 'block' : 'none'"  [src]="item.thumbnailImage" (load)="onImageLoad(item.id)"/>
                  </div>
                  @if (item.renderType == RenderType.Premium) {
                    <p-tag value="Premium" />
                  }
                </div>
              </div>
              <div class="title">
                <div class="large-text">
                  <h2 tooltipPosition="top" [pTooltip]="item.renderName">{{item.renderName}}</h2>
                  <h4>Size: {{item.imageSize[0]}}px x {{item.imageSize[1]}}px</h4>
                </div>
                <div class="metadata">
                  <p>Updated: {{item.lastUpdated | date: 'short' }}</p>
                  <p>Created: {{item.created | date: 'short' }}</p>
                </div>
              </div>
            </div>
            <div class="button-group">
              <p-button
                icon="pi pi-trash"
                [text]="true"
                [outlined]="true"
                severity="danger"
                pTooltip="Delete Render"
                tooltipPosition="bottom"
                (onClick)="confirmDelete($event, item.id)"
                [disabled]="item.isClone"
              />
              <p-button
                icon="pi pi-clone"
                [text]="true"
                [outlined]="true"
                severity="info"
                pTooltip="Clone Render"
                tooltipPosition="bottom"
                (onClick)="cloneRender(item.id)"
                [disabled]="item.isClone"
              />
              <p-button label="Open" icon="pi pi-image" size="small" iconPos="left" [text]="true" (onClick)="moveToEditor(item.id)" [disabled]="item.isClone" />
              <!-- <p-button icon="pi pi-star" [text]="true" [outlined]="true" severity="primary"  pTooltip="Star" tooltipPosition="bottom"/> -->
              <!-- <p-button icon="pi pi-cog" [text]="true" [outlined]="true" severity="secondary" pTooltip="Settings" tooltipPosition="bottom"/> -->
            </div>
          </div>
        }
      </ng-template>
    </p-dataView>
  }
</div>
